import { render, staticRenderFns } from "./orderMagtIndex.vue?vue&type=template&id=90fb651c"
import script from "./orderMagtIndex.vue?vue&type=script&lang=js"
export * from "./orderMagtIndex.vue?vue&type=script&lang=js"
import style0 from "./orderMagtIndex.vue?vue&type=style&index=0&id=90fb651c&prod&lang=scss"
import style1 from "./orderMagtIndex.vue?vue&type=style&index=1&id=90fb651c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports